
import { Component, Vue } from 'vue-property-decorator';
import { EliotModule } from '~/store/modules/eliot';
import { copyToClipboard } from '~common-helpers';
import { type } from '~/helpers/fields-description';
import { PlantDevice } from '~/interfaces/eliot.interface';
import Field from '~/components/Field.vue';

@Component({
    components: {
        Field,
    },
})
export default class ModulesList extends Vue {

    get currentGatewayModules() {
        return EliotModule.currentGatewayModules;
    }

    selectModule(moduleId: string) {
        EliotModule.setCurrentModuleId(moduleId);
    }

    isSelected(moduleId: string) {
        return moduleId === EliotModule.currentModuleId;
    }

    fieldsModule(mod: PlantDevice) {
        return [
            type(mod.deviceType),
            { key: 'Device', value: mod.device },
        ];
    }

    copyToClipboard(value: string) {
        copyToClipboard(value);
    }
}
